import { addMinutes } from 'date-fns';
import { toDate } from 'date-fns-tz';
import { DateSpan } from '../../../hooks/useSchedulingPreferences/types';
import { SchedulingPreferencesFormValues } from './types';

/**
 * Converts form data, which is in the user-selected timezone, to intermediate format
 * To do this we flatten the intervals to a single array of start/end Dates
 */
const formatAvailability = (
    availability: SchedulingPreferencesFormValues['availability'],
    timezoneId: string
): DateSpan[] => {
    return availability?.reduce<{ start: Date; end: Date }[]>(
        (allIntervals, intervalSet) => [
            ...allIntervals,
            ...intervalSet.intervals.map(({ start, end }) => {
                const dateStr = `${intervalSet.date}T00:00:00`;
                return {
                    start: addMinutes(toDate(dateStr, { timeZone: timezoneId }), start),
                    end: addMinutes(toDate(dateStr, { timeZone: timezoneId }), end),
                };
            }),
        ],
        []
    );
};

export default formatAvailability;
